import { FC } from "react";

import { Stack, useTheme } from "@mui/material";

import { CloseDialogButton } from "@/components/ShareFormModal/CloseDialogButton";
import { ShareFormTabLayout } from "@/components/ShareFormModal/ShareFormTabLayout";
import { DashboardSelectBarSkeleton } from "@/dashboard-design-system/SelectBar";
import { DashboardSkeleton } from "@/dashboard-design-system/Skeleton";

type HomeTabSkeletonProps = {
  isOnboarding?: boolean;
  onClose?: () => void;
};

export const HomeTabSkeleton: FC<HomeTabSkeletonProps> = ({ isOnboarding, onClose }) => {
  const theme = useTheme();

  const headerSkeletonColor = theme.palette.text.reverse.quiet;

  return (
    <ShareFormTabLayout
      slots={{
        closeButton: <CloseDialogButton onClick={onClose} />,
        header: (
          <Stack
            alignItems="center"
            gap={3}
            sx={{
              ["& .MuiSkeleton-root"]: {
                backgroundColor: headerSkeletonColor,
              },
            }}
          >
            <Stack width="100%" alignItems="center" gap={0.5}>
              <Stack width="100%" alignItems="center">
                <DashboardSkeleton width="100%" fontSize="h5" />
                <DashboardSkeleton width="60%" fontSize="h5" />
              </Stack>
              {isOnboarding && (
                <Stack width="100%" alignItems="center">
                  <DashboardSkeleton width="80%" fontSize="body1" />
                  <DashboardSkeleton width="60%" fontSize="body1" />
                </Stack>
              )}
            </Stack>
            <Stack direction="row" alignItems="center" width="100%" gap={1}>
              <DashboardSkeleton variant="rounded" height={36} sx={{ flex: 1 }} />
              <DashboardSkeleton variant="rounded" width={90} height={36} />
            </Stack>
            <Stack direction="row" alignItems="center" gap={2}>
              <DashboardSkeleton variant="circular" width={40} height={40} />
              <DashboardSkeleton
                variant="circular"
                width={40}
                height={40}
                sx={{ backgroundColor: headerSkeletonColor }}
              />
              <DashboardSkeleton variant="circular" width={40} height={40} />
            </Stack>
          </Stack>
        ),
        content: (
          <>
            {isOnboarding ? (
              <DashboardSkeleton
                variant="rounded"
                width="100%"
                maxWidth="175px"
                height={36}
                sx={{ marginInline: "auto" }}
              />
            ) : (
              <Stack gap={2}>
                <DashboardSelectBarSkeleton />
                <DashboardSelectBarSkeleton />
                <DashboardSelectBarSkeleton />
              </Stack>
            )}
          </>
        ),
      }}
    />
  );
};
